import {Component, Input, OnInit} from '@angular/core';
import {UnwetterMeldung} from '../../../../../../model/unwetter/unwetter';

@Component({
  selector: 'app-detail-expansion-panel',
  templateUrl: './detail-expansion-panel.component.html',
  styleUrls: ['./detail-expansion-panel.component.css', '../../unwetter-detail.component.css']
})
export class DetailExpansionPanelComponent implements OnInit {


  @Input()
  meldungen: Array<UnwetterMeldung>;
  @Input()
  isVorabInfo: boolean = false;
  panelOpenState: boolean = false;


  constructor() {
  }

  ngOnInit(): void {
  }

}
